// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3OJMx","itemA":"Write_itemA__2NOfU","itemB":"Write_itemB__23iED","itemC":"Write_itemC__1LUas","itemD":"Write_itemD__3b2bR"};